import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { Home, Phone } from "lucide-react";
import Navigation from "@/components/Navigation";
import Footer from "@/components/sections/Footer";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>Page Not Found | Altum Contractors</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="min-h-screen flex flex-col">
        <Navigation />
      
      <main className="flex-1 flex items-start justify-center bg-gradient-to-b from-light-gray to-white min-h-[70vh] pt-32 md:pt-40 pb-20 md:pb-24">
        <div className="container mx-auto px-4 text-center max-w-xl">
          <p className="section-eyebrow">Page Not Found</p>
          <h1 className="text-8xl md:text-9xl font-heading font-bold text-primary mb-6">
            404
          </h1>
          <p className="text-2xl md:text-3xl font-heading font-semibold text-navy mb-4">
            Looks like this page blew off in a storm
          </p>
          <p className="text-lg text-charcoal/70 mb-10 max-w-md mx-auto">
            Don't worry — we're experts at fixing what's missing. Let's get you back on solid ground.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild variant="cta" size="lg">
              <Link to="/">
                <Home className="w-5 h-5 mr-2" />
                Return to Safety
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="bg-white text-navy border-navy/30 hover:bg-navy hover:text-white hover:border-navy">
              <a href="tel:+13462200989">
                <Phone className="w-5 h-5 mr-2" />
                Call for Help
              </a>
            </Button>
          </div>
        </div>
      </main>

        <div className="h-px bg-navy/10" />
        <Footer />
      </div>
    </>
  );
};

export default NotFound;
